/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faPencil, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import { ContactBtn, InfoCard, InfoList } from '../ActiveCustomerDetails.styles';
import { updateActiveCustomerContactInformation } from '../../../features/activeCustomer/activeCustomerActions';
import FormReactSelectResidenceInput from '../../../common/formInputs/FormReactSelectResidenceInput';
import { commercialInitialData } from '../../../features/forms/formsActions';

const schema = yup.object({
    email: yup.string().email('Email non valida').required('Email è obbligatoria'),
    phone: yup.string().required('Telefono è obbligatorio'),
    address: yup.string().required('Indirizzo è obbligatorio'),
    house_number: yup.string().required('Civico è obbligatorio'),
    residence_commune_code: yup.string().required('Residenza è obbligatoria'),
    residence_province_code: yup.string().required('Provincia di residenza è obbligatoria'),
    postal_code: yup
        .string()
        .required('Il campo è obbligatorio. Inserisci codice postale!')
        .matches(/^[0-9]{5}$/, 'Il codice postale non e coretto'),
});

function ContactInformation({ activeCustomer, activeClientId }) {
    const navigate = useNavigate();
    const state = useSelector((store) => store.forms.commercial);
    const { municipalities } = state;
    const [editMode, setEditMode] = useState({ anagrafica: false, contatto: false });
    const { updatingContactLoading } = useSelector((state) => state.activeCustomers.active_customer);
    const {
        setValue, register, watch, formState: { errors },
    } = useForm({
        mode: 'all',
        resolver: yupResolver(schema),
        defaultValues: {
            email: '',
            phone: '',
            residence_province_code: '',
            residence_commune_code: '',
            postal_code: '',
            address: '',
            house_number: '',
        },
    });

    const formData = watch();

    const handleEditToggle = (section) => {
        setEditMode({ ...editMode, [section]: !editMode[section] });
    };

    const handleSave = (section) => {
        updateActiveCustomerContactInformation(activeClientId, formData, setEditMode, editMode, section);
    };

    const handleCancel = (section) => {
        setEditMode({ ...editMode, [section]: false });
    };

    useEffect(() => {
        commercialInitialData();
    }, []);

    useEffect(() => {
        if (editMode.contatto && municipalities.length > 0) {
            setValue('email', activeCustomer.email);
            setValue('phone', activeCustomer.phone);
            setValue('address', activeCustomer.address);
            setValue('house_number', activeCustomer.house_number);
            setValue('residence_commune_code', activeCustomer.residence_city_code);
            setValue('residence_province_code', activeCustomer.residence_province_code);
            setValue('postal_code', activeCustomer.postal_code);
        }
    }, [editMode, municipalities]);

    return (
        <div className="col-12 col-lg-6 active-client-single-page-four">
            <InfoCard>
                <div className="d-flex justify-content-between align-items-center mb-3 pb-3" style={{ borderBottom: '2px solid #f0f0f0' }}>
                    <h4 className="mb-0">Informazioni di Contatto</h4>
                    {!editMode.contatto ? (
                        <button
                            onClick={() => handleEditToggle('contatto')}
                            className="btn btn-sm btn-outline-success d-flex align-items-center gap-2"
                            style={{ border: 'none', background: 'transparent', color: '#00a651' }}
                        >
                            <FontAwesomeIcon icon={faPencil} />
                            Modifica
                        </button>
                    ) : (
                        <div className="d-flex gap-2">
                            <button
                                type="button"
                                onClick={() => handleSave('contatto')}
                                disabled={updatingContactLoading}
                                className="btn btn-sm btn-success d-flex align-items-center gap-1"
                            >
                                <FontAwesomeIcon icon={faCheck} />
                                {updatingContactLoading ? 'Salvando...' : 'Salva'}
                            </button>
                            <button
                                onClick={() => handleCancel('contatto')}
                                className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                            >
                                <FontAwesomeIcon icon={faTimes} />
                                Annulla
                            </button>
                        </div>
                    )}
                </div>

                {!editMode.contatto ? (
                    <>
                        <InfoList>
                            <li>
                                <strong>Email:</strong>
                                <span>{activeCustomer.email}</span>
                            </li>
                            <li>
                                <strong>Telefono:</strong>
                                <span>{activeCustomer.phone}</span>
                            </li>
                            <li>
                                <strong>Indirizzo:</strong>
                                <span>
                                    {activeCustomer.address}
                                    {' '}
                                    {activeCustomer.house_number}
                                </span>
                            </li>
                            <li>
                                <strong>Residenza:</strong>
                                <span>{activeCustomer.city_of_residence ? activeCustomer.city_of_residence.italian_name : ''}</span>
                            </li>
                            <li>
                                <strong>Codice Postale:</strong>
                                <span>{activeCustomer.postal_code}</span>
                            </li>
                        </InfoList>
                        <ContactBtn
                            onClick={() => navigate(`/customers/active-customer/${activeClientId}/contact`)}
                        >
                            Contatta Cliente
                        </ContactBtn>
                    </>
                ) : (
                    <div className="d-flex flex-column gap-3">
                        <div>
                            <label className="form-label fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Email</label>
                            <input
                                type="email"
                                name="email"
                                {...register('email')}
                                className="form-control"
                            />
                        </div>
                        <div>
                            <label className="form-label fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Telefono</label>
                            <input
                                type="tel"
                                name="phone"
                                {...register('phone')}
                                className="form-control"
                            />
                            <small className="form-text text-black d-block mt-1 fw-bold">
                                Inserire un numero di telefono reale (non fittizio).
                            </small>
                        </div>
                        <div className="row">
                            <div className="col-9">
                                <label className="form-label fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Indirizzo</label>
                                <input
                                    type="text"
                                    {...register('address')}
                                    className="form-control"
                                />
                            </div>
                            <div className="col-3">
                                <label className="form-label fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Civico</label>
                                <input
                                    type="text"
                                    {...register('house_number')}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div>
                            <FormReactSelectResidenceInput
                                label="Residenza"
                                labelClassName="form-label text-start fw-bold custom-label-size"
                                options={municipalities}
                                values={{
                                    residence_commune_code: formData.residence_commune_code || activeCustomer.residence_city_code,
                                    residence_province_code: formData.residence_province_code || activeCustomer.residence_province_code,
                                    postal_code: formData.postal_code || activeCustomer.postal_code,
                                }}
                                onChange={(val) => {
                                    setValue('residence_commune_code', val.residence_commune_code, {
                                        shouldValidate: true,
                                        shouldDirty: true,
                                        shouldTouch: true,
                                    });
                                    setValue('residence_province_code', val.residence_province_code, {
                                        shouldValidate: true,
                                        shouldDirty: true,
                                        shouldTouch: true,
                                    });
                                    setValue('postal_code', val.postal_code, {
                                        shouldValidate: true,
                                        shouldDirty: true,
                                        shouldTouch: true,
                                    });
                                }}
                                error={errors?.residence_province_code?.message}
                            />
                        </div>
                        <div>
                            <label className="form-label fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Codice Postale</label>
                            <input
                                type="text"
                                {...register('postal_code')}
                                className="form-control"
                            />
                            {errors.postal_code && (
                                <div className="text-danger mt-1" style={{ fontSize: '0.85rem' }}>
                                    {errors.postal_code.message}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </InfoCard>
        </div>
    );
}

export default ContactInformation;
